export const isString = (value) => typeof value === 'string' || value instanceof String
export const isNumber = (value) => !isNaN(parseFloat(value)) && isFinite(value)
